import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'htx-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './form.component.html',
  styleUrl: './form.component.scss'
})
export class FormComponent {

  /** The FormGroup that manages all form fields */
  formGroup = input.required<FormGroup>();

  /**
   * Returns whether the form has any errors
   */
  hasFormErrors(): boolean {
    return this.formGroup().invalid && this.formGroup().touched;
  }
}
